/**
 * Detects if the current user agent is a common search engine crawler (e.g., Googlebot, Bingbot, etc),
 * including Google's URL Inspection tool.
 * @returns {boolean} True if the user agent matches a known crawler, false otherwise.
 */
export function isCrawler(): boolean {
  if (typeof navigator === 'undefined') return false
  const userAgent = navigator.userAgent || ''

  // Common search engine crawler user agent patterns, including Google's URL Inspection tool
  const crawlerRegex =
    /\b(Googlebot|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Sogou|Exabot|facebot|ia_archiver|Google-InspectionTool)\b/i

  return crawlerRegex.test(userAgent)
}
